import { HISTORICO_SIMULACAO_MENU } from "@/modules/recursos/simulacao";

import { PERSPECTIVA_OPTIONS, type CargaPerspectiva } from "../../carga-de-trabalho.constants";
import type { CargaToolbarProps, CargaToolbarViewModel } from "./types-carga-toolbar";

/** Barra da Carga de Trabalho: busca, período, "Visualizar por", filtros, perspectiva e o ⋮ (Simulação, Papéis, Exportar, Indicadores). */
export function useCargaToolbar({
  perspectiva,
  onPerspectiva,
  ...props
}: CargaToolbarProps): CargaToolbarViewModel {
  const { menu } = props;
  const prefixo = props.ids.perspectivaPrefixo;

  return {
    ...props,
    perspectivas: {
      value: perspectiva,
      options: PERSPECTIVA_OPTIONS,
      // O `SelectButton` devolve `null` ao clicar na opção já escolhida: a perspectiva atual fica.
      onChange: ({ value }) => {
        if (value) onPerspectiva(value as CargaPerspectiva);
      },
      pt: {
        button: (opcoes) => ({
          "data-testid": prefixo
            ? `${prefixo}-${(opcoes?.context.option as { value: CargaPerspectiva }).value}`
            : undefined,
        }),
      },
    },
    entrarSimulacao: menu.onEntrarSimulacao ?? null,
    historico: menu.onAbrirHistorico
      ? { label: HISTORICO_SIMULACAO_MENU, onAbrir: menu.onAbrirHistorico }
      : null,
    simulacaoDesabilitada: menu.simulando,
  };
}
